import { customFieldsPayload, toPayloadAddress } from "components/BaseForm";

// The legacy form sent cleared text fields as null, not as empty strings.
const toNullableText = value => value.trim() || null;

/** Form values as the update request body. */
export const toCasePayload = (values, { customFieldConfigs }) => ({
  name: values.name.trim(),
  entity_id: values.entity_id,
  case_investigators: values.case_investigators,
  investigation_status_id: values.investigation_status_id,
  website: values.website,
  industry: toNullableText(values.industry),
  company_description: toNullableText(values.company_description),
  actionable_domain: toNullableText(values.actionable_domain),
  region_id: values.region_id,
  country: values.country,
  source_status_id: values.source_status_id,
  product_line_id: values.product_line_id,
  addresses: values.addresses.map(toPayloadAddress),
  tags: values.tags,
  custom_fields: customFieldsPayload(customFieldConfigs, values.custom_fields),
});
